import React from "react";

function CreditCell(data) {
  return <div>{data?.credit === 0 ? "" : data?.credit}</div>;
}

export default CreditCell;
